/* LARGO — fiabilité du panier avec Releasit COD.
 *
 * Contexte : le panier de ce thème met à jour son contenu par AJAX
 * (changement de quantité, suppression) sans recharger la page, via une
 * fusion DOM ciblée (morph). Le bouton injecté par Releasit COD n'existe
 * pas dans le HTML renvoyé par le serveur pour ces mises à jour — il est
 * ajouté côté client par le script de l'application, et ne survit pas
 * toujours à cette mise à jour partielle selon son point de montage exact.
 *
 * Plutôt que de deviner la mécanique interne de Releasit (ce qui
 * risquerait de dupliquer son bouton s'il n'est pas conçu pour se
 * réinitialiser plusieurs fois sur une même page), on redonne à
 * l'application les conditions dans lesquelles elle fonctionne déjà de
 * manière fiable et vérifiée : un vrai chargement de page.
 *
 * Déclencheur : l'événement réel 'cart:update' du thème, qui se produit
 * uniquement après qu'une mise à jour du panier a réussi côté serveur.
 * Désactivé dans l'éditeur de thème pour ne jamais interrompre une
 * session d'édition du marchand.
 */
(function () {
  function boot() {
    if (window.Shopify && window.Shopify.designMode) return;

    var main = document.getElementById('MainContent');
    if (!main || main.dataset.template !== 'cart') return;

    var reloading = false;

    document.addEventListener('cart:update', function () {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
